import { Content, ContentHeader, CreateButton, Header, SupportButton } from '@backstage/core-components';
import {
  CatalogFilterLayout,
  EntityOwnerPicker,
  EntityTagPicker,
  UserListPicker,
  EntityListProvider,
} from '@backstage/plugin-catalog-react';
import {
  EntityListDocsTable,
  TechDocsIndexPageProps,
  TechDocsPageWrapper,
  TechDocsPicker,
} from '@backstage/plugin-techdocs';
import { Entity } from '@backstage/catalog-model';

export type CustomTechDocsHomeProps = {
  groups?: Array<{
    title: React.ReactNode;
    filterPredicate: (entity: Entity) => boolean;
  }>;
};

export type DefaultTechDocsHomeProps = TechDocsIndexPageProps;

export const CustomTechDocsHome = (props: TechDocsIndexPageProps) => {
  const { initialFilter = 'owned', columns, actions } = props;
  return (
    <TechDocsPageWrapper>
      <Header title="Tech Docs" subtitle="Playbooks, User Guides, Team Docs, Best Practices, and more" />
      <Content>
        <ContentHeader title="">
          <CreateButton title="CREATE DOCUMENTATION" to="/create/templates/default/docs-template" />
          <SupportButton>Discover documentation in your ecosystem.</SupportButton>
        </ContentHeader>
        <EntityListProvider>
          <CatalogFilterLayout>
            <CatalogFilterLayout.Filters>
              <TechDocsPicker />
              <UserListPicker initialFilter={initialFilter} />
              <EntityOwnerPicker />
              <EntityTagPicker />
            </CatalogFilterLayout.Filters>
            <CatalogFilterLayout.Content>
              <EntityListDocsTable actions={actions} columns={columns} />
            </CatalogFilterLayout.Content>
          </CatalogFilterLayout>
        </EntityListProvider>
      </Content>
    </TechDocsPageWrapper>
  );
};
